export const accountLinksNav = [
        {
          "name": "Account Settings",
          "link": "/my-account",
          "uid": "AccountLinksSection",
        },
        {
          "name": "PC Optimum",
          "link": "/my-account/optimum",
          "uid": "ShoppersOptimumRewardsLink",
        },
        {
          "name": "Order History",
          "link": "/my-account/orders",
          "uid": "OrderHistoryLink",
        },
        {
          "name": "Shipping Information",
          "link": "/my-account/address-book",
          "uid": "AddressesLink",
        },
        {
          "name": "Payment Information",
          "link": "/my-account/payment-details",
          "uid": "PaymentInfoLink",
        },
        {
          "name": "Favourites",
          "link": "/favourite",
          "uid": "FavouritesLink",
        },
        {
          "name": "Log Out",
          "link": "/logout",
          "uid": "SignOutLink",
        }
      ];